import './App.css';
import Home from './Routes/Home';
import Projects from './Routes/Projects';
import Contact from './Routes/Contact';
import About from './Routes/About';
import { Route, Routes } from 'react-router-dom';



function App() {
  return (
    <>
    <Routes>
    <Route path='/' element={<Home />} />
    <Route path='/projects' element={<Projects />} />
    <Route path='/about' element={<About />} />
    <Route path='/contact' element={<Contact />} />
    </Routes>
    </>
  );
  };

export default App;
